// import agent from "../agent";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MUSIC_PLAY, MUSIC_TABLE_UNLOAD, SHOW_SHOP_CAR, CHECK_PRICE_GROUP } from "constants/actionTypes";
import { Pagination } from "antd";
import Loading from "components/Loading";
import MusicTableCell from "components/Music/comps/MusicTableCell";
import FavoriteTableCell from "components/Music/comps/FavoriteTableCell";
import { addCart, addFavorite, rmFavorite, redirectTo, noLoginAddCart, noShowPage } from "dispatch";
import agent from "agent";
import "./page.less";
const queryString = require("query-string");

const mapStateToProps = (state, ownProps) => ({
    ...state.musicTable,
    ...ownProps,
    pagination: ownProps.pagination || state.musicTable.pagination,
    loading:
        typeof ownProps.loading === "boolean"
            ? ownProps.loading
            : state.musicTable.loading,
    tableData:
        typeof ownProps.tableData !== "undefined"
            ? ownProps.tableData
            : state.musicTable.tableData,
    musicPlay: state.player.audio,
    userLogin: state.app.userLogin,
    labels: state.labels.labelsDataAll,
});

const mapDispatchToProps = dispatch => ({
    playMusic: musicPlay => {
        return dispatch({ type: MUSIC_PLAY, musicPlay });
    },
    unLoadTable: () => {
        return dispatch({ type: MUSIC_TABLE_UNLOAD });
    },
    showCarPopup: addAudio => {
        return dispatch({ type: SHOW_SHOP_CAR, addAudio });
    },
    checkPriceGroup: id => {
        return dispatch({
            type: CHECK_PRICE_GROUP,
            payload: agent.PriceGroup.get(id),
        });
    },
});

class MusicTable extends React.Component {
    static propTypes = {
        pagination: PropTypes.object.isRequired,
        loading: PropTypes.bool.isRequired,
        tableData: PropTypes.array,
        musicPlay: PropTypes.object,
        loadData: PropTypes.func.isRequired,
        unLoadTable: PropTypes.func.isRequired,
        playMusic: PropTypes.func.isRequired,
        one: PropTypes.bool,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        inverted_condition: PropTypes.object,
        one_id: PropTypes.number,
        showCarPopup: PropTypes.func.isRequired,
        checkPriceGroup: PropTypes.func.isRequired,
    };
    state = {
        folderPicker: null,
        folders: [],
        selectedFolders: [],
        newFolderName: "",
        creatingFolder: false,
        folderError: "",
    };
    componentDidMount() {
        if (!this.props.disableAutoLoad) {
            this.loadCurrentPageData();
        }
    }

    loadCurrentPageData = () => {
        const { loadData, pagination, location, one, inverted_condition, one_id, disableAutoLoad } = this.props;
        if (one) {
            const pager = {
                current: 1,
                pagerSize: 4
            }
            const theSame = {
                sameStyle: inverted_condition.style,
                sameEmotion: inverted_condition.emotion,
                sameScene: inverted_condition.scene,
                sameInstrument: inverted_condition.instrument,
                oneId: one_id,
            }
            const params = {
                page: 1,
                size: 4,
                ...theSame,
            };
            loadData(pager, params);
        } else if (!disableAutoLoad) {
            const pager = { ...pagination };
            pager.current = 1; // default
            const query = queryString.parse(location.search);
            const params = {
                page: pager.current,
                ...query,
                size: pagination.pageSize,
            };
            // reset from params
            pager.current = parseInt(params.page);
            loadData(pager, params);
        }

    };

    componentWillUnmount() {
        this.props.unLoadTable();
    }

    onPageChange(pageNumber) {
        const { loadData, pagination, match, location } = this.props;
        const pager = { ...pagination };
        pager.current = pageNumber;
        const query = queryString.parse(location.search);
        let tiao = noShowPage.baseDecode(query.tiao);
        const params = {
            ...tiao,
            page: pager.current,
        };
        const stringTiao = {
            tiao: noShowPage.baseEecode(params),
        }
        const stringified = queryString.stringify(stringTiao);
        redirectTo({
            pathname: match.url,
            search: `?${stringified}`,
        });
        params.size = pagination.pageSize;
        loadData(pager, params);
    }

    idFavoritePage = () => {
        const { match } = this.props;
        return match.path.indexOf("/favorite") === 0;
    };

    async clickFavorite(audio) {
        const { userLogin } = this.props;
        if (!userLogin) {
            // login first
            redirectTo("/login");
            return;
        }
        if (audio.like && this.idFavoritePage()) {
            rmFavorite({ audioid: audio.audioid, like_id: audio.like.id }, () => this.loadCurrentPageData());
            return;
        }
        // Open immediately so a slow/unavailable folder API cannot hide the picker.
        this.setState({ folderPicker: audio, folders: [], selectedFolders: [], newFolderName: "", folderError: "" });
        try {
            const response = await agent.FavoriteFolder.load();
            const folders = (response.body || response).folders || [];
            if (this.state.folderPicker && this.state.folderPicker.id === audio.id) {
                this.setState({ folders });
            }
        } catch (e) {
            console.log("收藏夹加载失败", e);
        }
    }

    confirmFavorite = async () => {
        const { folderPicker: audio, selectedFolders } = this.state;
        if (!audio.like) addFavorite({ audioid: audio.audioid });
        try {
            await Promise.all(selectedFolders.map(id => agent.FavoriteFolder.addAudio(id, audio.id)));
        } catch (e) {
            console.log("收藏加入文件夹失败", e);
        }
        this.setState({ folderPicker: null });
    };

    createFavoriteFolder = async event => {
        event.preventDefault();
        const name = this.state.newFolderName.trim();
        if (!name || this.state.creatingFolder) return;
        this.setState({ creatingFolder: true, folderError: "" });
        try {
            await agent.FavoriteFolder.create(name);
            const response = await agent.FavoriteFolder.load();
            const folders = (response.body || response).folders || [];
            const createdFolder = folders.find(folder => folder.name === name);
            this.setState(state => ({
                folders,
                selectedFolders: createdFolder
                    ? Array.from(new Set(state.selectedFolders.concat(createdFolder.id)))
                    : state.selectedFolders,
                newFolderName: "",
            }));
        } catch (e) {
            this.setState({ folderError: "创建文件夹失败，请重试。" });
        } finally {
            this.setState({ creatingFolder: false });
        }
    };

    handleAddCart(audio) {
        const { userLogin } = this.props;
        if (!userLogin) {
            // login first
            //redirectTo("/login");
            noLoginAddCart(audio);
            return;
        }
        addCart(audio);
    }
    showCarPopup(audio) {
        const { showCarPopup, checkPriceGroup } = this.props;
        const send = {
            showAddCar: true,
            addAudio: audio,
        };
        checkPriceGroup(audio.price_group_id);
        showCarPopup(send);
    }
    renderCell(audio, i) {
        const { musicPlay, playMusic, labels } = this.props;
        audio.playing =
            !!musicPlay && musicPlay.id === audio.id && !!musicPlay.playing;

        const dispatch = {
            labels,
            playMusic,
            clickFavorite: this.clickFavorite.bind(this),
            addCart: this.showCarPopup.bind(this),
        };
        console.log(audio, dispatch)
        if (this.idFavoritePage()) {
            return <FavoriteTableCell key={`cel-${i}`} audio={audio} {...dispatch} />;
        }
        return <MusicTableCell key={i} audio={audio} {...dispatch} />;
    }
    render() {
        const { loading, pagination, labels, tableData: audios, one, emptyText, hidePagination } = this.props;
        const isShow = one ? "resultPagination hidden" : "resultPagination page-left";
        if (!audios) {
            return (
                <div className="resultItemWrapper">
                    <Loading loading={loading} />
                </div>
            );
        }
        if (!labels) {
            return (
                <div className="resultItemWrapper">
                    <Loading loading={loading} />
                </div>
            );
        }
        if (!audios || !audios.length) {
            return (
                <div className="resultItemWrapper text-center">
                    <p>{emptyText || "没有音乐"}</p>
                </div>
            );
        }
        return (
            <div className="resultItemWrapper c02b478-music-table">
                {this.state.folderPicker && (
                    <div className="favoriteFolderPicker">
                        <div className="favoriteFolderPicker__dialog">
                            <h3>选择收藏文件夹</h3>
                            <form className="favoriteFolderPicker__create" onSubmit={this.createFavoriteFolder}>
                                <input
                                    value={this.state.newFolderName}
                                    onChange={event => this.setState({ newFolderName: event.target.value })}
                                    placeholder="新建文件夹名称"
                                    aria-label="新建文件夹名称"
                                />
                                <button type="submit" disabled={this.state.creatingFolder || !this.state.newFolderName.trim()}>{this.state.creatingFolder ? "创建中…" : "创建文件夹"}</button>
                            </form>
                            {this.state.folderError && <p role="alert">{this.state.folderError}</p>}
                            {this.state.folders.length ? this.state.folders.map(folder => (
                                <label key={folder.id}>
                                    <input type="checkbox" checked={this.state.selectedFolders.indexOf(folder.id) !== -1} onChange={() => this.setState(state => ({ selectedFolders: state.selectedFolders.indexOf(folder.id) === -1 ? state.selectedFolders.concat(folder.id) : state.selectedFolders.filter(id => id !== folder.id) }))} /> {folder.name}
                                </label>
                            )) : <p>暂无文件夹，可在上方创建。</p>}
                            <button disabled={this.state.creatingFolder} onClick={this.confirmFavorite}>确认收藏</button>
                            <button onClick={() => this.setState({ folderPicker: null })}>取消</button>
                        </div>
                    </div>
                )}
                <Loading loading={loading} />
                {audios.map(this.renderCell.bind(this))}
                {!hidePagination && (
                    <div className=" page-ov">
                        {/**搜索页的显示跳十页 */}
                        <div className={isShow} >
                            <Pagination
                                defaultPageSize={pagination.pageSize}
                                {...pagination}
                                defaultCurrent={1}
                                hideOnSinglePage={true}
                                onChange={this.onPageChange.bind(this)}
                                // showTotal={total => `/${Math.ceil(total / 10)} 页`}
                                showQuickJumper
                            />
                        </div>
                    </div>
                )}
                {/* <div className="totlPageClass">/ {Math.ceil(pagination.total / 10)} 页</div> */}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MusicTable);
